import { getMaskedEmail } from "@/common/utils/utils";
import moment from "moment";
import { routerNames } from "../appCommon.constants.js";
import {commonEnvVariables} from '@/commonEnvVariables';
import uniqBy from 'lodash/uniqBy';
import { emailConstants } from "./privacysettings.constants.js";

const envVariables = commonEnvVariables();
export const userTypes = {
    MEMBER: "Member",
    TEAM_MEMBER: "Team Member",
    CHAPTER_MANAGER: "Chapter Manager",
    CHAPTER_ADMINISTRATOR: "Chapter Administrator",
    GROUP_SUPER_ADMIN: "Group Super Administrator",
    SPOUSE_PARTNER: "Spouse/Partner",
    TEAM_MEMBER_PRODUCT_MANAGEMENT: "Team Member Product Management",
};
export const myAccountConstants = {
    menu: [
        {
            title: 'My Account',
            key: 'myAccount',
            componentName: '',
            url: '',
            showForMember: true,
            showForExternalSpeaker: false,
            subMenu: [
                {
                    componentName: 'ChangeUsername',
                    title: 'Change My Username',
                    key: 'changeUserName',
                    showInMobileApp: false,
                },
                {
                    componentName: 'ChangePassword',
                    title: 'Change My Password',
                    key: 'changePassword',
                    showInMobileApp: true,
                },
                {
                    componentName: '',
                    title: 'Manage Login Security',
                    key: 'manageLoginSecurity',
                    showInMobileApp: true,
                    routeName: 'loginSecurity',
                },
                {
                    componentName: '',
                    title: 'Review My Invoices',
                    key: 'invoices',
                    showInMobileApp: true,
                },
                //Todo: Wait for this to be developed.
                // {
                //     componentName: '',
                //     title: 'Save My Payment Method',
                //     key: 'paymentMethod',
                // },
                {
                    componentName: '',
                    title: 'Purchase Benefits',
                    key: 'benefits',
                    showInMobileApp: true,
                },
                {
                    componentName: '',
                    title: 'Access Digital Wallet',
                    key: "paymentInfo",
                    showInMobileApp: true,
                },
                {
                    componentName: '',
                    title: 'Manage My Chapters',
                    key: "manageMyChapters",
                    showInMobileApp: true,
                },
            ],
        },
        {
            title: 'Emails & Notifications',
            key: 'privacySettings',
            componentName: '',
            url: '#/privacySettings/emailSettings',
            showForMember: true,
            showForExternalSpeaker: false,
        },
        {
            title: 'M2Mx',
            key: 'm2mx',
            componentName: '',
            url: '',
            showForMember: true,
            showForExternalSpeaker: false,
            subMenu: [
                {
                    componentName: '',
                    parent: 'm2mx',
                    title: 'Overview of Services',
                    key: 'overviewOfServices',
                    url: process.env.VUE_APP_M2MX_OVERVIEW_OF_SERVICES,
                },
                {
                    componentName: '',
                    parent: 'm2mx',
                    title: 'Request Assistance',
                    key: 'requestAssistance',
                    url: `${process.env.VUE_APP_YPO_CONCIERGE_PORTAL}/s/request-assistance`,
                },
                {
                    componentName: '',
                    parent: 'm2mx',
                    title: 'Update M2Mx Profile',
                    key: 'updateM2MxProfile',
                    url: process.env.VUE_APP_M2MX_PROFILE_URL,
                },                
            ],
        },        
        {
            title: 'Resource Directory Terms of Use',
            key: 'TermsOfUse',
            componentName: '',
            url:
            `${envVariables.BLOB_CDN_END_POINT}/publiclyaccessiblefiles/YPO_Non_Solicitation_Policy.pdf`,
            showForMember: false,
            showForExternalSpeaker: true,
        },
        //Todo: Wait for this to be developed.
        // {
        //     title: 'Help',
        //     key: 'help',
        //     componentName: '',
        //     url: 'https://www.ypowpo.org/portal/department/help',
        // },
        {
            title: 'Contact Us',
            key: 'contact',
            componentName: 'ContactUs',
            url: '',
            showForMember: true,
            showForExternalSpeaker: true,
        },
    ],
    LOG_OUT: 'LOG OUT',
    EDIT_PROFILE: 'EDIT PROFILE',
    CANCEL: 'Cancel',
    SAVE: 'Save',
    My_ACCOUNT: 'My Account',
    YPO_MEMBER_ID: 'YPO Member ID:',
    UPDATE_M2MX_PROFILE: 'updateM2MxProfile',
    REQUEST_ASSISTANCE: 'requestAssistance',

    passwordConstants: {
        CURRENT_PASSWORD: 'Current Password',
        NEW_PASSWORD: 'New Password',
        CONFIRM_NEW_PASSWORD: 'Confirm New Password',
        CURRENT_PASSWORD_REQUIRED: 'Current Password Required',
        UPPER_CASE_NOTATION: 'A',
        LOWER_CASE_NOTATION: 'a',
        NUMBER_OR_SPECIAL_CHAR_NOTATION: '123!',
        UPPERCASE_COUNT: '1',
        UPPERCASE: 'Uppercase',
        LOWERCASE_COUNT: '1',
        LOWERCASE: 'Lowercase',
        NUMBER_OR_SPECIAL_CHARACTER_COUNT: '1',
        NUMBER_OR_SPECIAL_CHARACTER: 'Number or Special Character',
        TOTAL_CHARACTERS_COUNT: '10',
        CHARACTERS_TOTAL: 'Characters Total',
        PASSWORDS_DO_NOT_MATCH: 'Passwords do not match',
        INCORRECT_CURRENT_PASSWORD: 'Please confirm that you have entered your current password correctly.',
        NEW_AND_CURRENT_PASSWORD_CANNOT_BE_SAME:
            'Your new password cannot be the same as your current password. Please choose another password.',
        PASSWORD_CHANGE_SUCCESS: 'You successfully changed your password',
        OKTA_MSG_OLD_PASSWORD_INCORRECT: 'Old Password is not correct',
        OKTA_MSG_OLD_PASSWORD_INCORRECT2: 'Your old password is not valid.  Try again with the correct password.',
        OKTA_MSG_CURRENT_PASSWORD_SAME: 'Password cannot be your current password',
        OKTA_MSG_CURRENT_PASSWORD_SAME2: 'Your new password must not be the same password as your old password',
        PASSWORD_WARNING:
            'We’re unable to change your password. Please try again later.  We apologize for any inconvenience.',
        ZERO: 0,
        TEN: 10,
    },

    myProfileConstants: {
        MY_PROFILE_TITLE: 'My Profile',
        PROFILE_COMPLETE: '% Profile Complete',
    },
};

export const userProfileName = (profileInformation) => {
    let userProfileNameText = '';
    if (profileInformation) {
        if (profileInformation.preferredName) {
            userProfileNameText = `${profileInformation.preferredName} ${profileInformation.lastName}`;
            return userProfileNameText;
        }
        if (!profileInformation.preferredName) {
            userProfileNameText = `${profileInformation.firstName} ${profileInformation.lastName}`;
            return userProfileNameText;
        }
    }
};

export const changeUserNameConstants = {
    CURRENT_USERNAME: 'Current Username',
    NEW_USERNAME: 'New Username',
    CANCEL: 'Cancel',
    SAVE: 'Save',
    USERNAME_CHANGED_CONIFRMATION: 'You  successfully changed your username',
    USERNAME_EXISTS_ERROR: 'Username already exists. Please choose another username.',
    USERNAME_VALIDATION_TEXT: '3-64 characters with letters, numbers and underscores only',
    USERNAME_WARNING:
        'We’re unable to change your username. Please try again later.  We apologize for any inconvenience.',
    USERNAME_EXISTS: 'Username already exists',
    THREE: 3,
    SIXTY_FOUR: 64,
    EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
};

export const contactUsConstants = {
    menu: [        
        {
            title: 'YPO Concierge',
            key: 'ypoConcierge',
            urlTitle: 'concierge@ypo.org',
            url: 'concierge@ypo.org',
            description: 'Your global experts for all things YPO',
            showForMember: true,
            showForExternalSpeaker: false,
        },
        {
            title: 'M2Mx',
            key: 'm2mx',
            urlTitle: 'M2Mx@ypo.org',
            url: 'M2Mx@ypo.org',
            description: '',
            showForMember: true,
            showForExternalSpeaker: false,
        },
    ],    
    PHONE_NUMBER1: '+1 972 587 1500',
    MEMBER_SERVICES_NUMBER: '+1 800 425 5418',
    SUPPORT_EMAIL: "concierge@ypo.org",
};

export const renewalConstants = {
    START: 'RENEW NOW',
    START_RENEWAL_BTN: 'RENEW TODAY. START HERE.',
    SHOW_INVOICE: 'VIEW INVOICE',
    QUICK_START: 'QUICK START',
    CONTINUE: 'CONTINUE',
    BANNER_TITLE: 'No member left behind',
    BANNER_SUBTITLE:
        'Our commitment is to help every member be in a position to continue engaging with YPO next fiscal year.' +
        ' YPO is freezing the current dues rates, offering deferred payment options and suspending certifications for this membership renewal period.',
    QUICK_START_TIP:
        'If your personal and family information is up-to-date, “Quick Start” expedites your renewal process.',

    RENEWAL: 'Renewal',
    RENEW_NOW: 'Renew Now',
    RENEW_CONTINUE: 'Continue',
    RENEW_SHOW_INVOICE: 'Show Invoice',
    RENEW_NOW_TITLE: 'The future can’t wait!',
    RENEW_NOW_TITLE1: 'OUR LEGACY IS OUR FUTURE.',
    RENEW_NOW_TITLE2: 'because we learn, grow and evolve, together.',
    RENEW_NOW_TITLE3: 'Renew your membership today.',
    RENEW_NOW_SUBTITLE: 'Individually and together our extraordinary leaders are the catalyst for the next 75 years of YPO. Lead On!',
    CONTINUE_TITLE: 'The future can’t wait!',
    CONTINUE_TITLE1: 'Together we lead…',
    CONTINUE_TITLE2: 'YOUR MEMBERSHIP RENEWAL IS NOT YET COMPLETE.',
    CONTINUE_SUBTITLE: 'Select “Continue” to complete your membership renewal and stay connected to everything you need for a fulfilling business, personal and family journey. The deadline to renew is 30 June.',
    VIEW_INVOICE_TITLE: 'The future can’t wait!',
    VIEW_INVOICE_TITLE1: 'Together we lead…',
    VIEW_INVOICE_TITLE2: 'THANK YOU FOR YOUR COMMITMENT TO THE YPO COMMUNITY!',
    VIEW_INVOICE_SUBTITLE: 'Your membership renewal is complete. If you would like a record of your completed renewal, please select “View Invoice” to view, print and save your invoice.',
    YPO_JOURNEY_URL:'https://event.ypo.org/event/62619368-5c0a-46b2-9e35-b6553fa484f6/summary?RefId=CNT&utm_source=Onboarding',
};

export const loginSecurityConstants = {
    LOGIN_SECURITY: 'Manage Login Security',
    PASSWORD_RESET_TITLE: "Check Your Inbox",
    PASSWORD_RESET_EMAIL_PHRASE: `Didn't receive an email? Contact <a style="font-weight: 600; color: #44779F; text-decoration: none" href="mailto:${contactUsConstants.SUPPORT_EMAIL}">YPO Concierge</a>.`,
    PASSWORD_RESET_WARNING: "For your online security and data privacy, we may periodically ask you to reset your password.",
    PASSWORD_CHANGE_INTRO_LABEL: "Your new password cannot be the same as your previous password and must contain:",
    SECURITY_DESCRIPTION: 'Never share your YPO Connect username and password. In addition to your username and password, you are now required to set up and manage additional layers of security. The next time you log into Connect or other YPO global services, YPO will ask to confirm the information you provide below.',
    SECURITY_NOTE: 'Email offers the most versatility.',
    SECURITY_NOTE_LABEL: 'Note: ',
    LOGIN_HEADER: 'Extra Login Verification',
    AMFA_ERROR_MSG: 'You must select at least one Multi-factor authentication option',
    SETUP: 'Set Up',
    EDIT: 'Edit',
    REMOVE: 'Remove',
    CANCEL: 'Cancel',
    EMAIL: 'Email',
    QUESTION: 'Your favorite question',
    QUESTION_PLACEHOLDER: 'Select favorite question',
    PHONE_NUMBER: 'Phone Number',
    SEND_CODE: 'Send Code',
    RESEND_CODE: 'Resend Code',
    CONFIRM: 'Confirm',
    AUTHENTICATION_CODE: 'YPO Verification Code',
    PROVIDER: 'OKTA',
    FACTOR_SMS: 'sms',
    FACTOR_EMAIL: 'email',
    FACTOR_QUESTION: 'question',
    FACTOR_STATUS_ACTIVE: "ACTIVE",
    FACTOR_STATUS_PENDING_ACTIVATION: "PENDING_ACTIVATION",
    FACTOR_CONFIRMATION_MESSAGE: 'That number has already been validated. No need to send you a code. Please Confirm to complete setup.',
    passwordComplexityKeys: {
        minLength: "minLength",
        minLowerCase: "minLowerCase",
        minUpperCase: "minUpperCase",
        minNumber: "minNumber",
        minSymbol: "minSymbol",
        excludeUsername: "excludeUsername",
        excludeAttributes: "excludeAttributes",
        firstName: "firstName",
        lastName: "lastName",
    },
};

export const getInterstitialPasswordResetEmailMessage = (email) => {
    const emailAddress = email ? getMaskedEmail(email) : "your primary email address";
    return `We just emailed you at <span style="font-weight: 600; opacity: 0.8">${emailAddress}</span>. To continue, please open the email from YPO Concierge and click 
    the link inside to reset your password. Look for the subject line "YPO Connect Password Reset."`;
};

export const getBasicLoginSecurityOptions = () => {
    return [
        {
            title: 'Verify by Text/SMS',
            key: loginSecurityConstants.FACTOR_SMS,
            description: 'Enter a code sent to your mobile device',
            factorType: loginSecurityConstants.FACTOR_SMS,
            isEnabled: false,
            inEditMode: false,
            isActivationCodeSent: false,
            sendCodeErrorMsg: "",
            confirmAuthenticationErrorMsg: "",
            metadata: {
                profile: {
                    phoneNumber: "",
                },
            },
        },
        {
            title: 'Verify by Email',
            sub_title: '(Strongly Recommended)',
            key: loginSecurityConstants.FACTOR_EMAIL,
            description: 'Enter a code sent to your YPO email address',
            factorType: loginSecurityConstants.FACTOR_EMAIL,
            isEnabled: false,
            inEditMode: false,
            isActivationCodeSent: false,
            sendCodeErrorMsg: "",
            confirmAuthenticationErrorMsg: "",
            metadata: {
                profile: {
                    email: "",
                },
            },
        },
        {
            title: 'Verify by Secret Question',
            key: loginSecurityConstants.FACTOR_QUESTION,
            description: 'Answer a question that you can select from a list here',
            sub_description: 'Consider sharing the answer with your executive assistant',
            factorType: loginSecurityConstants.FACTOR_QUESTION,
            isEnabled: false,
            inEditMode: false,
            isActivationCodeSent: false,
            sendCodeErrorMsg: "",
            confirmAuthenticationErrorMsg: "",
            metadata: {
                profile: {
                    answer: "",
                    question: "",
                    questionText: "",
                },
            },
        },
    ];
};

export const passwordComplexityRequirement = [
    {
        key: loginSecurityConstants.passwordComplexityKeys.minLength,
        label: "At least 10 characters",
        regexTest: "",
    },
    {
        key: loginSecurityConstants.passwordComplexityKeys.minLowerCase,
        label: "A lowercase letter",
        regexTest: "",
    },
    {
        key: loginSecurityConstants.passwordComplexityKeys.minUpperCase,
        label: "An uppercase letter",
        regexTest: "",
    },
    {
        key: loginSecurityConstants.passwordComplexityKeys.minNumber,
        label: "A number",
        regexTest: "",
    },
    {
        key: loginSecurityConstants.passwordComplexityKeys.minSymbol,
        label: "A special character",
        regexTest: "",
    },
    {
        key: loginSecurityConstants.passwordComplexityKeys.excludeUsername,
        label: "Does not contain part of username",
        regexTest: "",
    },
    {
        key: "excludeAttributes",
        label: "",
        additionalDetail: {
            firstName: {
                key: loginSecurityConstants.passwordComplexityKeys.firstName,
                label: "Does not contain first name",
                regexTest: "",
            },
            lastName: {
                key: loginSecurityConstants.passwordComplexityKeys.lastName,
                label: "Does not contain last name",
                regexTest: "",
            },
        },
    },
];

export const getPasswordComplexityRequirement = (passwordPolicySetting) => {
    const result = [];
    if (passwordPolicySetting && Object.keys(passwordPolicySetting).length) {
        Object.keys(passwordPolicySetting).forEach((complexityKey) => {
            if (passwordPolicySetting[complexityKey]) {
                if (complexityKey === loginSecurityConstants.passwordComplexityKeys.excludeAttributes) {
                    if (passwordPolicySetting[complexityKey].length) {
                        const excludeAttributesSetting = passwordComplexityRequirement
                            .find(req => req.key === loginSecurityConstants.passwordComplexityKeys.excludeAttributes);
                        passwordPolicySetting[complexityKey].forEach((itemKey) => {
                            if (excludeAttributesSetting.additionalDetail
                                && excludeAttributesSetting.additionalDetail.hasOwnProperty(itemKey)) {
                                result.push(excludeAttributesSetting.additionalDetail[itemKey]);
                            }
                        });
                    }
                } else {
                    const setting = passwordComplexityRequirement.find(req => req.key === complexityKey);
                    if (setting && setting.key === loginSecurityConstants.passwordComplexityKeys.minLength) {
                        setting.label = `At least ${passwordPolicySetting[complexityKey]} characters`;
                    }
                    if (setting) result.push(setting);
                }
            }
        });
    }
    return result;
};

export const getWelcomeBannerText = (profileInformation, target) => {
  const fullName = profileInformation.preferredName
    ? `${profileInformation.preferredName}`
    : `${profileInformation.firstName}`;
  return `Welcome ${fullName}! Your first 90 days at YPO: How to make the most of your membership.  <a href="${renewalConstants.YPO_JOURNEY_URL}" style="color: white; text-decoration: underline; font-weight: bold;" target="${target}">Click here</a> to find out more.`;
};

export const showNewMemberBanner = (profileInformation, route) => {
  let showBanner = false;
  const joinDate = profileInformation.joindate
    ? moment.utc(profileInformation.joindate)
    : null;
  if (joinDate) {
    const currentDate = moment.utc();
    const differenceInDays = currentDate.diff(joinDate, "days");
    console.log(
      "differenceInDays",
      differenceInDays,
      profileInformation.joindate
    );
    if (
      differenceInDays >= 1 && differenceInDays <= 90 &&
      profileInformation.recordTypeName === userTypes.MEMBER &&
      route === routerNames.HOME
    ) {
      showBanner = true;
    }
  }
  return showBanner;
};

export function addAllOption(communicationPreferences, allLabel = emailConstants.SELECT_ALL ) {
    Object.values(communicationPreferences).forEach((category) => {
        Object.keys(category).forEach((subhead) => {
            const allChecked = category[subhead]
                .filter((pref) => pref.preferenceSalesforceValue !== allLabel)
                .every((pref) => pref.isPreferenceEnabled);

            const selectAllPreference = category[subhead].find(
                (pref) => pref.preferenceSalesforceValue === allLabel
            );

            if (!selectAllPreference) {
                category[subhead].unshift({
                    isPreferenceEnabled: allChecked,
                    preferenceDescriptiveLabel: allLabel,
                    preferenceSalesforceValue: allLabel,
                    isDisabled: false,
                });
            } else {
                selectAllPreference.isPreferenceEnabled = allChecked;
            }
            category[subhead] = uniqBy(category[subhead], 'preferenceSalesforceValue');
        });
    });

    return communicationPreferences;
}

